import { GetAccountsPositionsHistoryResponse } from '@goldwasserexchange/actor/rest-services';
import { getFileName } from './getFileName';
import { AccountDocument } from '../../../accounts/documents/type';
import { AccountHistory } from '../../../accounts/history/type';
import { AccountsOrder } from '../../../accounts';

export const arDocHasFileName = (data?: AccountHistory | AccountDocument | AccountsOrder | GetAccountsPositionsHistoryResponse) => {
  const fileName = getFileName(data);
  return fileName !== '' && fileName != null;
};
